import { STATIC_STRINGS } from "@asez/shared";
import EmailInputCard from "./EmailInputCard";
import FileUploadCard from "./FileUploadCard";

const AddCandidates = () => {
  return (
    <div className="text-sm xl:text-base">
      <div className="px-2 font-semibold text-gray-500">
        {STATIC_STRINGS.ADD_CANDIDATE_HEADING}
      </div>
      <div className="flex justify-between items-center h-60">
        <FileUploadCard />
        <EmailInputCard />
      </div>
    </div>
  );
};

export default AddCandidates;
